import {ChangeEvent, FC, ReactNode} from 'react';
import {extractInnDigits, formatInnDisplay, InnStepValues} from '../../model';
import {StepLayout} from 'features/registration';
import {TextInput} from '../components/TextInput';
import styles from './InnStep.module.css';

const DEFAULT_SUBTITLE = 'Нужен для работы и декларации доходов в РФ';

type Props = {
	values: InnStepValues;
	error?: string | null;
	onChange: (patch: Partial<InnStepValues>) => void;
	onFindInn?: () => void;
	subtitle?: ReactNode;
};

export const InnStep: FC<Props> = ({
	values,
	error,
	onChange,
	onFindInn,
	subtitle = DEFAULT_SUBTITLE,
}) => {
	const handleInnChange = (event: ChangeEvent<HTMLInputElement>) => {
		onChange({inn: extractInnDigits(event.target.value)});
	};

	return (
		<StepLayout variant="fill">
			<StepLayout.Intro title="Введите ИНН" subtitle={subtitle} compact subtitleMuted />

			<StepLayout.Content className={styles.field}>
				<TextInput
					name="inn"
					className={styles.innInput}
					value={formatInnDisplay(values.inn)}
					placeholder="0000 0000 0000"
					inputMode="numeric"
					autoComplete="off"
					autoFocus
					aria-invalid={Boolean(error)}
					onChange={handleInnChange}
					onClear={() => onChange({inn: ''})}
				/>
				{error ? <p className={styles.error}>{error}</p> : null}
				<StepLayout.TextLink onClick={onFindInn}>Узнать свой ИНН</StepLayout.TextLink>
			</StepLayout.Content>
		</StepLayout>
	);
};
